module.exports = __webpack_public_path__ + "img/icn_check_kenben.fa448e84.png";